/* Ship dates (owner 2026-10-12): "In stock · ships Oct 26" under Add to cart; in the cart, "· ships Oct 26" once in the
   summary's shipping row (owner 10-26: it sat on every cart line).
   Owner 10-24: "skip weekend, but fulfill next day unless it's more than 30 pending". The date is the next business day
   after today, at any hour (Theme settings > Ship dates: earliest and latest day, both 1). Once more than the capacity
   (30) orders are waiting to ship, each further batch of 30 adds a business day: 31-60 waiting +1, 61-90 +2 (My
   Subscription app, /apps/my-subscription/ship-queue, counted once a minute). Business days run Monday to Friday, New
   York time, minus Thanksgiving, Christmas, New Year's Day and the extra closed days in the settings. If the count can't
   be read (after a retry and the last count this browser saw), no date shows. Sold-out items keep their preorder window (snippets/rn-preorder).
   Readers: both buy-box scripts call RoniniShip.text() and repaint on "rn:ship-window"; the cart summaries carry
   [data-rn-ship="lower"] (sections/cart-drawer, sections/ronini-main-cart), filled here, also after the cart
   re-renders. Any [data-rn-ship] gets "Ships Oct 26"; "lower" gets "ships Oct 26", to follow other words. */
(function () {
  'use strict';
  if (window.RoniniShip) return;
  var node = document.getElementById('rn-ship-cfg');
  if (!node) return;
  var cfg;
  try { cfg = JSON.parse(node.textContent); } catch (e) { return; }

  function num(v, d) { v = Number(v); return isFinite(v) ? v : d; }
  var MIN = Math.max(0, Math.round(num(cfg.min, 1)));
  var MAX = Math.max(MIN, Math.round(num(cfg.max, 1)));
  var CAP = Math.max(0, Math.round(num(cfg.capacity, 30)));
  var EXTRA = String(cfg.closed || '').split(/[\s,]+/).filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });
  var ENDPOINT = cfg.endpoint || '/apps/my-subscription/ship-queue';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var KEY = 'rn-ship-queue';
  var TTL = 60000;

  function iso(d) { return d.toISOString().slice(0, 10); }
  function thanksgiving(y) {
    var first = new Date(Date.UTC(y, 10, 1)).getUTCDay();
    return iso(new Date(Date.UTC(y, 10, 1 + ((4 - first + 7) % 7) + 21)));
  }
  function closed(d) {
    var dow = d.getUTCDay();
    if (dow === 0 || dow === 6) return true;
    var s = iso(d), md = s.slice(5);
    return md === '12-25' || md === '01-01' || s === thanksgiving(d.getUTCFullYear()) || EXTRA.indexOf(s) !== -1;
  }
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) {
      x.setUTCDate(x.getUTCDate() + 1);
      if (!closed(x)) n--;
    }
    return x;
  }
  // Today's date and the hour in New York, whatever the shopper's own time zone.
  function nowNY(at) {
    var p = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(at || new Date()).forEach(function (part) { p[part.type] = part.value; });
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), hour: (+p.hour % 24) + (+p.minute) / 60 };
  }
  function format(a, b) {
    var first = MONTHS[a.getUTCMonth()] + ' ' + a.getUTCDate();
    if (iso(a) === iso(b)) return first;
    var sameMonth = a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear();
    return first + '–' + (sameMonth ? '' : MONTHS[b.getUTCMonth()] + ' ') + b.getUTCDate();
  }
  // Counted from today's New York date: Saturday, Sunday and Friday all give Monday. Up to CAP waiting adds nothing.
  function windowText(open, at) {
    var today = nowNY(at).date;
    var extra = CAP > 0 ? Math.floor(Math.max(0, (open || 0) - 1) / CAP) : 0;
    return format(addBusinessDays(today, MIN + extra), addBusinessDays(today, MAX + extra));
  }

  function readCache() {
    try {
      var v = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (v && typeof v.open === 'number' && Date.now() - v.t < TTL) return v.open;
    } catch (e) {}
    return null;
  }
  function writeCache(open) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ open: open, t: Date.now() })); } catch (e) {}
  }
  // 10-14 (owner: "based on unfulfilled orders, not by product"): a failed or slow count used to fall back to 0
  // orders waiting, so one page could show the no-backlog window while the others showed the real one. Now: retry,
  // then the last count this browser saw (kept 6 hours), and if there is none, no date at all rather than a wrong one.
  var LAST = 'rn-ship-queue-last';
  function readLast() {
    try {
      var v = JSON.parse(localStorage.getItem(LAST) || 'null');
      if (v && typeof v.open === 'number' && Date.now() - v.t < 6 * 3600000) return v.open;
    } catch (e) {}
    return null;
  }
  function fetchOnce(ms) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    return fetch(ENDPOINT, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        if (!r.ok) throw new Error('ship-queue ' + r.status);
        return r.json();
      })
      .then(function (d) {
        if (timer) clearTimeout(timer);
        var open = Number(d && d.open);
        if (!isFinite(open)) throw new Error('ship-queue: no count');
        writeCache(open);
        try { localStorage.setItem(LAST, JSON.stringify({ open: open, t: Date.now() })); } catch (e) {}
        return open;
      }, function (err) { if (timer) clearTimeout(timer); throw err; });
  }
  function load() {
    var cached = readCache();
    if (cached !== null) return Promise.resolve(cached);
    return fetchOnce(8000)
      .catch(function () { return new Promise(function (r) { setTimeout(r, 1500); }).then(function () { return fetchOnce(8000); }); })
      .catch(function () { return readLast(); });
  }

  var state = { text: '' };
  function paint(root) {
    if (!state.text) return;
    var text = 'Ships ' + state.text;
    var lower = 'ships ' + state.text;
    (root || document).querySelectorAll('[data-rn-ship]').forEach(function (el) {
      var t = el.getAttribute('data-rn-ship') === 'lower' ? lower : text;
      if (el.textContent !== t) el.textContent = t;
      el.hidden = false;
    });
  }
  function settle(open) {
    if (open === null || open === undefined) return; // count unknown: show no date rather than a wrong one
    var text = windowText(open);
    if (text === state.text) return;
    state.text = text;
    paint();
    document.dispatchEvent(new CustomEvent('rn:ship-window', { detail: { text: text } }));
  }

  window.RoniniShip = {
    text: function () { return state.text; },
    windowText: windowText
  };

  load().then(settle);
  // A page left open past midnight moves on by itself.
  setInterval(function () { load().then(settle); }, 5 * 60000);

  // The cart drawer and page re-render their lines; fill the new ones.
  if (typeof MutationObserver === 'function') {
    new MutationObserver(function (records) {
      if (!state.text) return;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-rn-ship') || n.querySelector('[data-rn-ship]'))) { paint(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
